








































import { $store } from "@/store";
import { Vue, Component } from "vue-property-decorator";
import PdfViewer from "../pdf_viewer/PdfViewer.vue";
import PdfViewerTools from "../pdf_viewer/PdfViewerTools.vue";

@Component({
  components: {
    "ag-pdf-viewer": PdfViewer,
    "ag-pdf-viewer-tools": PdfViewerTools,
  },
})
export default class DesignLayoutForm extends Vue {
  get elemHeight() {
    return $store.appearance.appHeight;
  }

  get hideLayoutToolbar() {
    return $store.appearance.hideLayoutToolbar;
  }

  get pdfViewerPageWidth() {
    return $store.appearance.pdfViewerPageWidth;
  }

  cancel() {
    $store.wizard.exitWizard({ result: "canceled" });
  }

  nextStep() {
    $store.wizard.layoutStep++;
  }
}
